import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Stack, Typography } from '@vapor/material'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RateRestriction } from 'src/api/api.generated'

type UnavailableResourceModalProps = {
  open: boolean
  handleClose: () => void
  errors: {
    resourceUnavailable: boolean
    rateIsStopSell: boolean
    restrictionsNotMet: RateRestriction[] | null | undefined
  }
  onConfirm: () => void
}

export default function UnavailableResourceModal(props: UnavailableResourceModalProps) {
  const { open, handleClose, errors, onConfirm } = props
  const { t } = useTranslation()

  const [content, setContent] = useState(<></>)

  useEffect(() => {
    const errorsList: JSX.Element[] = []
    if (errors.resourceUnavailable) {
      errorsList.push(<li key={'resourceUnavailable'}>{t('pms.booking.reservation_new.unavailable_modal.error.resource_unavailable')}</li>)
    }
    if (errors.rateIsStopSell) {
      errorsList.push(<li key={'rateIsStopSell'}>{t('pms.booking.reservation_new.unavailable_modal.error.resource_stop_sell')}</li>)
    }
    if (errors.restrictionsNotMet) {
      errors.restrictionsNotMet.forEach((restriction) => {
        switch (restriction) {
          case RateRestriction.MINSTAY:
            errorsList.push(
              <li key={RateRestriction.MINSTAY}>
                <Typography variant="body">{t('pms.booking.reservation_new.unavailable_modal.error.min_stay')}</Typography>
              </li>,
            )
            break
          case RateRestriction.MAXSTAY:
            errorsList.push(
              <li key={RateRestriction.MAXSTAY}>
                <Typography variant="body">{t('pms.booking.reservation_new.unavailable_modal.error.max_stay')}</Typography>
              </li>,
            )
            break
          case RateRestriction.ADVANCE:
            errorsList.push(
              <li key={RateRestriction.ADVANCE}>
                <Typography variant="body">{t('pms.booking.reservation_new.unavailable_modal.error.advance')}</Typography>
              </li>,
            )
            break
          case RateRestriction.CTA:
            errorsList.push(
              <li key={RateRestriction.CTA}>
                <Typography variant="body">{t('pms.booking.reservation_new.unavailable_modal.error.cta')}</Typography>
              </li>,
            )
            break
          case RateRestriction.CTD:
            errorsList.push(
              <li key={RateRestriction.CTD}>
                <Typography variant="body">{t('pms.booking.reservation_new.unavailable_modal.error.CTD')}</Typography>
              </li>,
            )
            break
          case RateRestriction.LASTMINUTE:
            errorsList.push(
              <li key={RateRestriction.LASTMINUTE}>
                <Typography variant="body">{t('pms.booking.reservation_new.unavailable_modal.error.last_minutes')}</Typography>
              </li>,
            )
            break
          case RateRestriction.STOPSELL:
            errorsList.push(
              <li key={RateRestriction.STOPSELL}>
                <Typography variant="body">{t('pms.booking.reservation_new.unavailable_modal.error.stop_sell')}</Typography>
              </li>,
            )
            break
          case RateRestriction.STOPSELL_CHARGE:
            errorsList.push(
              <li key={RateRestriction.STOPSELL_CHARGE}>
                <Typography variant="body">{t('pms.booking.reservation_new.unavailable_modal.error.stop_sell_charge')}</Typography>
              </li>,
            )
            break
        }
      })
    }
    setContent(
      errorsList.length > 0 ? (
        <div>
          <ul>{errorsList}</ul>
        </div>
      ) : (
        <></>
      ),
    )
  }, [errors])

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>{t('pms.booking.reservation_new.unavailable_modal_title')}</DialogTitle>
      <DialogContent>
        <Stack direction="column" spacing={1}>
          <Typography variant="body">{t('pms.booking.reservation_new.unavailable_modal_content_1')}</Typography>
          {content}
          <Typography variant="body">{t('pms.booking.reservation_new.unavailable_modal_content_2')}</Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="outlined">
          {t('commons.cancel')}
        </Button>
        <Button onClick={onConfirm} autoFocus variant="contained">
          {t('commons.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
